export default {
  submenu: 'Sottomenu:',
  content: 'Contenuto',
  overview: 'Panoramica ',
  longTermSupport: 'Supporto a Lungo Termine',
  skillsAndTalents: 'Competenze e Talenti',
  yourMap: 'La tua Mappa',
  motivationAndEmotionalIntelligence: 'Motivazione ed intelligenza emotiva',
  alliancesCompromisesAndResources: 'Alleanze, compromessi e risorse',
  skillsToStartABusiness: 'Abilità per avviare un\'impresa',
  accountingAndFinance: 'Contabilità e Finanza',
  settingUpYourOwnBusiness: 'Impostare il proprio business',
  accountingBasics: 'Nozioni base di contabilità',
  openingABankAccount: 'Apertura di un conto bancario',
  businessPlanBasicInformation: 'Nozioni base sul piano aziendale',
  taxes: 'Tasse',
  legalFormsOfEmployment: 'Forme giuridiche del lavoro',
  marketingAndSales: 'Marketing e vendite',
  whatAreMyProducts: 'Quali sono i miei prodotti?',
  whoAreMyClients: 'Chi sono i miei clienti?',
  communication: 'Comunicazione',
  positioning: 'Posizionamento',
  sales: 'Vendite',
  uniqueSellingPoints: 'Punti vendita unici',
  publicRelations: 'Relazioni pubbliche',
  introduction: 'Introduzione',
  strategy: 'Strategia',
  messagesAndTools: 'Messaggi e strumenti',
  digitalPRAndSMRevolution: 'Le PR.digitali e la rivoluzione dei social media',
  it: 'IT (Tecnologia Informatica)',
  cloudVSOnPremises: 'Differenza tra Cloud e On Premise',
  email: 'Email',
  onlineMarketing: 'Marketing online',
  webshop: 'Negozio elettronico',
  website: 'Sito web'
}



// WEBPACK FOOTER //
// ./src/i18n/contentnav/it.js